import OnboardingForm from "../components/onboarding/onboarding-form";

export default function OnboardingPage() {
  return (
    <>
        <OnboardingForm />
    </>
  );
}
